import {
  FETCH_MATERIAL_TRANSFER,
  RESET_MATERIAL_TRANSFER,
} from "../../constants/action.constants";
// import { getPayloadData } from "../../constants/apiRequestData";
// import { API_ROUTES, API_ROUTES_KEY } from "../../constants/apiRoutes";
import { getAccessToken } from "../../services/browserStorage";
import { webApiCheck } from "../../services/commonMethods";
import { postDashboardWebApi } from "../../webApis/apiResource";

// export const requestMaterialTransfer = (id) => {
//   return async (dispatch) => {
//     const response = await postDashboardWebApi(
//       getAccessToken(),
//       API_ROUTES[API_ROUTES_KEY.GET_MATERIAL_TRANSFER],
//       getPayloadData(API_ROUTES_KEY.GET_MATERIAL_TRANSFER, false, {
//         id,
//       })
//     );
//     if (webApiCheck(response)) {
//       dispatch(fetchMaterialTransferOrder(response.data.data));
//     }
//   };
// };
export const requestMaterialTransfer = (urlEndPoint, payload) => {
  return async (dispatch) => {
    const response = await postDashboardWebApi(
      getAccessToken(),
      urlEndPoint,
      payload
    );
    if (webApiCheck(response)) {
      dispatch(fetchMaterialTransferOrder(response.data));
    }
  };
};

const fetchMaterialTransferOrder = (resp) => {
  const { data, ...others } = resp;
  return {
    type: FETCH_MATERIAL_TRANSFER,
    payload: data,
    others,
  };
};

export const resetMaterialTransferOrder = () => {
  return {
    type: RESET_MATERIAL_TRANSFER,
  };
};
